/**
 * src/admin-ui/src/components/AppShell.tsx
 *
 * Shared protected-page layout with fixed-footer clearance.
 */

import React from "react";
import { styled } from "@mui/material/styles";
import Footer from "./Footer";

interface AppShellProps {
  children: React.ReactNode;
}

// Pages follow the full-screen pattern and size themselves against the
// footer (var(--app-footer-height)) — the shell adds no extra clearance.
const ShellMain = styled("main")({
  minHeight: "100vh",
});

/**
 * Render protected page content inside the common application shell.
 *
 * :param children: Current page.
 * :returns: Main content and responsive footer.
 */
export default function AppShell({
  children,
}: AppShellProps): React.ReactElement {
  return (
    <>
      <ShellMain>{children}</ShellMain>
      <Footer />
    </>
  );
}
